module.exports = __webpack_public_path__ + "img/triangle.0ccb8bad.svg";